/*
  Wire America: preselect a purchase option when the product page loads, so
  Add to Cart is live on arrival (Google Merchant Center "User cannot complete
  purchase").
  Order of preference:
    1. the variant in ?variant= (the link Google and ads send people to)
    2. By the Foot, when the product sells by the foot
    3. otherwise the first option, which is the smallest spool (250 ft) or the
       only variant
  Quote-only variants (own box or quote-only colour) are skipped in 2 and 3.
  Colour products get the first colour that has the chosen option.
  Selection goes through a real click on each radio, so the theme's own
  handlers update price, calculator, stock and the button exactly as a
  shopper's click would.
*/
(function () {
  // Variants sold by quote only (their own box, or a quote-only colour such as
  // Black). Never landed on by default, so the page opens on a buyable option.
  var quoteIds = [];
  try {
    var q = document.getElementById('wa-quote-variants');
    if (q) quoteIds = JSON.parse(q.textContent).map(String);
  } catch (e) { quoteIds = []; }
  function buyable(v) { return quoteIds.indexOf(String(v.id)) === -1; }
  function priced(v) { return v.available && v.price > 0 && buyable(v); }
  function isFoot(v) {
    return v.options.some(function (o) { return /by the foot/i.test(o); });
  }

  function pickTarget(variants) {
    var id = new URLSearchParams(window.location.search).get('variant');
    if (id) {
      var linked = variants.find(function (v) { return String(v.id) === id && v.available; });
      if (linked) return linked;
    }
    return variants.find(function (v) { return priced(v) && isFoot(v); }) ||
      variants.find(priced) ||
      variants.find(function (v) { return v.available && buyable(v); }) ||
      variants.find(function (v) { return v.available; }) ||
      null;
  }

  function run() {
    var selects = document.querySelector('variant-selects[id^="variant-selects-"]');
    if (!selects || selects.dataset.waDefaulted) return;
    selects.dataset.waDefaulted = 'true';

    var json = selects.querySelector('script[type="application/json"]');
    var fieldsets = selects.querySelectorAll('fieldset[data-index]');
    if (!json || !fieldsets.length) return;
    if (selects.querySelector('fieldset[data-index] input[type="radio"]:checked')) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var target = pickTarget(variants);
    if (!target) return;

    fieldsets.forEach(function (fieldset) {
      var value = target.options[parseInt(fieldset.dataset.index, 10)];
      if (value == null) return;
      var radio = Array.prototype.find.call(
        fieldset.querySelectorAll('input[type="radio"]'),
        function (input) { return input.value === value; }
      );
      if (radio && !radio.checked) radio.click();
    });

    // Colour products sold by the foot: the theme reloads the length box with
    // its own "Select Color" list once By the Foot is chosen. Pick the same
    // colour there, or Add to Cart stops and asks for it.
    if (isFoot(target) && selects.querySelector('[data-filedset-color="true"]')) {
      pickLengthColour(selects, target);
    }
  }

  function pickLengthColour(selects, target) {
    var wrapper = selects.closest('.productinfo-wrapper');
    if (!wrapper) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var row = wrapper.querySelector('.quantity-box.length-active .fieldset_qty--wrapper');
      if (row) {
        clearInterval(timer);
        var fieldset = row.querySelector('fieldset[data-index]');
        if (!fieldset) return;
        var current = fieldset.querySelector('.select-selected.not-active');
        if (!current) return;
        var colour = target.options[parseInt(fieldset.dataset.index, 10)];
        var item = Array.prototype.find.call(
          fieldset.querySelectorAll('.items[data-value]'),
          function (el) { return el.dataset.value === colour; }
        );
        if (item && item.dataset.waQuote !== 'true') item.click();
      } else if (tries > 50) {
        clearInterval(timer);
      }
    }, 150);
  }

  function safeRun() {
    try { run(); } catch (e) { /* never block the page; shopper can still pick */ }
  }

  function start() {
    if (window.jQuery && customElements.get('variant-selects')) safeRun();
    else window.addEventListener('load', safeRun, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
